// extracted by mini-css-extract-plugin
export default {"container":"ip-z","bubbleNav":"jp-z","graphic":"kp-z","contact":"lp-z"};